import * as firebase from "firebase/app";
import "firebase/storage";
import "firebase/firestore";

var firebaseConfig = {
  apiKey: "AIzaSyDDBGungy9ydxBbNjML2f8S5opShRdTkJg",
  authDomain: "uttar-gallary.firebaseapp.com",
  projectId: "uttar-gallary",
  storageBucket: "uttar-gallary.appspot.com",
  messagingSenderId: "531815721185",
  appId: "1:531815721185:web:561fd99f1abdade777afa0",
};

// Initialize Firebase
firebase.initializeApp(firebaseConfig);

const projectStorage = firebase.storage();
const projectFirestore = firebase.firestore();
const timestamp = firebase.firestore.FieldValue.serverTimestamp;

export { projectStorage, projectFirestore, timestamp };
